export const INSTALLATION_SUMMARY_LIST_COLS = [
  {
    key: "Bundle Id",
    value: "bundleId",
    isFilterEnabled: false,
    filterType: "String",
    isVehicle: true,
    width: "9%",
  },
  {
    key: "Subscription Name",
    value: "subscription",
    isFilterEnabled: false,
    filterType: "String",
    isTraits: true,
    width: "17%",
  },
  {
    key: "Tech Ref ID",
    value: "techRefId",
    isFilterEnabled: false,
    filterType: "String",
    isVehicleStatus: true,
    width: "14%",
  },
  {
    key: "Order Quantity",
    value: "ordered",
    isFilterEnabled: false,
    filterType: "String",
    isType: true,
    width: "9%",
  },
  {
    key: "Fallout",
    value: "fallout",
    isFilterEnabled: false,
    filterType: "String",
    isSubName: true,
    width: "6%",
  },
  {
    key: "Service Name",
    value: "serviceName",
    isFilterEnabled: false,
    filterType: "String",
    isTechRef: true,
    width: "17%",
  },
  {
    key: "Not Scheduled",
    value: "notScheduled",
    isFilterEnabled: false,
    filterType: "String",
    isHardName: true,
    width: "9%",
  },
  {
    key: "Scheduled",
    value: "scheduled",
    isFilterEnabled: false,
    filterType: "String",
    isHardId: true,
    width: "7%",
  },
  {
    key: "Installed",
    value: "installed",
    isFilterEnabled: false,
    filterType: "String",
    isHardId: true,
    width: "6%",
  },
  {
    key: "Past Due",
    value: "pastDue",
    isFilterEnabled: false,
    filterType: "String",
    isHardId: true,
    width: "6%",
  },
];
